import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as SentryIntegration } from '@sentry/integrations'
// import { Integrations } from '@sentry/tracing' CORS проблемы
import { isDocApplication } from '@/utils/app.js'

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_SENTRY_ENV,
  release: process.env.VUE_APP_SENTRY_RELEASE,
  autoSessionTracking: true,
  maxBreadcrumbs: 50,
  tracesSampleRate: 0.25,
  integrations: [
    // new Integrations.BrowserTracing({
    // tracingOrigins: ['http://localhost:8080', 'http://192.168.88.254:8080', 'localhost:4000', '188.225.18.7:9000']
    // }),
    new SentryIntegration({
      Vue,
      attachProps: true,
      logErrors: true
      // TOOD: с трейсингом CORS проблемы...
      // tracing: true,
      // tracingOptions: {
      //  trackComponents: true
      // }
    })
  ]
  // tracesSampleRate: 1.0
})

Sentry.setTag('project', isDocApplication ? 'front-contract' : 'front-assistant')
